<template>
  <div class="mb40">
    <div class="mb20">
      <span class="title">{{ item.name }}</span>
      <yxtf-tag
        v-if="item.current && showTag"
        class="ml8"
        size="mini"
        type="warning"
      >
        {{ $t('pc_gwnl_web_competencyStandards') }}
      </yxtf-tag>
    </div>
    <div
      v-if="item.description"
      class="mb16"
    >
      <div class="label mb8">
        {{ $t('pc_gwnl_global_lbl_levelDescription') }}
      </div>
      <div
        class="info"
        v-text="item.description"
      />
    </div>
    <div v-if="item.behavior">
      <div class="label mb8">
        {{ $t('pc_gwnl_global_lbl_behavior') }}
      </div>
      <div
        class="info"
        v-text="item.behavior"
      />
    </div>
  </div>
</template>
<script>
export default {
  inject: ['showTag'],
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style scoped lang="scss">
.title {
  color: #262626;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
}

.label {
  color: #8c8c8c;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.info {
  color: #595959;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
